export const Bot = ({ fill = "white" }: { fill?: string }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1362_8930"
      style={{ maskType: "luminance" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="32"
    >
      <path d="M32 0H0V32H32V0Z" fill={fill ? "white" : fill} />
    </mask>
    <g mask="url(#mask0_1362_8930)">
      <path
        d="M27.6177 10.8375L27.2889 11.5918C27.0484 12.1439 26.2846 12.1439 26.044 11.5918L25.7153 10.8375C25.1293 9.49267 24.0738 8.42192 22.7568 7.83615L21.7438 7.38567C21.1962 7.14208 21.1962 6.34512 21.7438 6.10153L22.7001 5.67623C24.051 5.07539 25.1254 3.96502 25.7013 2.57448L26.0389 1.75942C26.2742 1.19136 27.0588 1.19136 27.294 1.75942L27.6316 2.57448C28.2076 3.96502 29.282 5.07539 30.6329 5.67623L31.589 6.10153C32.1368 6.34512 32.1368 7.14208 31.589 7.38567L30.5762 7.83615C29.2592 8.42192 28.2037 9.49267 27.6177 10.8375ZM26.6665 14.6667C27.5592 14.6667 28.4177 14.5204 29.2194 14.2507C29.2945 14.8232 29.3332 15.4071 29.3332 16C29.3332 23.3638 23.3636 29.3334 15.9998 29.3334C13.7298 29.3334 11.5924 28.7662 9.7214 27.7656L2.6665 29.3334L4.23425 22.2784C3.23376 20.4075 2.6665 18.27 2.6665 16C2.6665 8.63624 8.63604 2.66671 15.9998 2.66671C17.2073 2.66671 18.3773 2.82723 19.4897 3.12808C18.9626 4.19493 18.6665 5.39624 18.6665 6.66671C18.6665 11.085 22.2482 14.6667 26.6665 14.6667ZM9.33317 16C9.33317 19.6819 12.3179 22.6667 15.9998 22.6667C19.6817 22.6667 22.6665 19.6819 22.6665 16H19.9998C19.9998 18.2092 18.209 20 15.9998 20C13.7906 20 11.9998 18.2092 11.9998 16H9.33317Z"
        fill={fill ? fill : "white"}
      />
    </g>
  </svg>
);
